import ReviewDetail from './ReviewDetail.container';

export default ReviewDetail;
